module.exports = __webpack_public_path__ + "media/images/ControllerDarkVertical-5f5d5214.jpg";